import { Box, Typography } from "@maysoft/common-component-react";
import { Card, Icon } from "@mui/material";
import { useMemo } from "react";

import useStrings from "../../hooks/useStrings";
import DialogInviteMember from "./dialogInviteMember";
import TableMember from "./tableMember";

import { ICodename } from "../../commons/interfaces";
import { ChannelPagingType } from "../../constants/enums";
import { useCommunityCommonContext } from "../../providers/CommunityCommonProvider";

const CommunityMember = () => {
    const Strings = useStrings();
    const propsData = useCommunityCommonContext();

    const listChannels = useMemo(
        () => [...(propsData.listChannels || [])].map((item) => ({ code: item.id, name: item.name } as ICodename)),
        [propsData.listChannels]
    );

    return (
        <Card>
            <Box p={3}>
                <Box
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box style={{ display: "flex", alignItems: "center" }}>
                        <Icon sx={{ fontWeight: "bold", marginRight: 1 }}>people</Icon>
                        <Typography variant="h5" fontWeight="bold">
                            {Strings.MEMBER.LIST_MEMBER}
                        </Typography>
                    </Box>

                    <Box mx={2} display="flex">
                        <DialogInviteMember
                            hidenInputCommunity={true}
                            type={ChannelPagingType.Community}
                            roleList={[]}
                            listCommunitys={[]}
                            communityCode={propsData.communityCode}
                            channelId={propsData.channelId}
                            listChannels={listChannels || []}
                        />
                    </Box>
                </Box>

                <Box sx={{ paddingTop: "16px", paddingX: "16px" }}>
                    <TableMember type={ChannelPagingType.Community} discussionGroupId={propsData.communityId || ""} />
                </Box>
            </Box>
        </Card>
    );
};

export default CommunityMember;
